/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourlistinghasbeencreatedsuccessfully5Inputs */

const en_yourlistinghasbeencreatedsuccessfully5 = /** @type {(inputs: Yourlistinghasbeencreatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your listing has been created successfully.`)
};

const de_yourlistinghasbeencreatedsuccessfully5 = /** @type {(inputs: Yourlistinghasbeencreatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Ort wurde erstellt.`)
};

/**
* | output |
* | --- |
* | "Your listing has been created successfully." |
*
* @param {Yourlistinghasbeencreatedsuccessfully5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourlistinghasbeencreatedsuccessfully5 = /** @type {((inputs?: Yourlistinghasbeencreatedsuccessfully5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourlistinghasbeencreatedsuccessfully5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourlistinghasbeencreatedsuccessfully5(inputs)
	return de_yourlistinghasbeencreatedsuccessfully5(inputs)
});
export { yourlistinghasbeencreatedsuccessfully5 as "yourListingHasBeenCreatedSuccessfully" }